import { keyframes, styled } from '../../../lib/stitches'
import { gray15 } from '../../platform/color'

const move = keyframes({
  '0%': { transform: 'translateX(-100%)' },
  '100%': { transform: 'translateX(100%)' }
})

const StyledProgressContainer = styled('div', {
  height: '8px',
  background: 'rgba(0,0,0,0.1)',
  borderRadius: '4px',
  overflow: 'hidden',
  variants: {
    infinite: {
      true: {
        '&::after': {
          display: 'block',
          content: '',
          height: '100%',
          background: gray15,
          width: '100%',
          animation: '2s ease infinite ' + move
        }
      }
    }
  }
})

const Progress = StyledProgressContainer

export default StyledProgressContainer
